import { UI, Stack } from '@genial/components';
import { RouteProp } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';

import { SignedInRootStackParamList } from '../../../../../routes/types';
import { SubscriptionCustomersList } from '../../SubscriptionCustomersList';
import { SubscriptionHistory } from '../../SubscriptionHistory';

export interface SubscriptionDetailsTabsProps {
  isMobile: boolean;
  params: RouteProp<SignedInRootStackParamList, 'SubscriptionDetails'>['params'];
}

export const SubscriptionDetailsTabs: React.FC<SubscriptionDetailsTabsProps> = (props) => {
  const { isMobile, params } = props;

  const initialTab = params?.initialTab;

  const tabs = [
    {
      key: 'newSubscription',
      label: 'Solicitar Subscrição',
      component: <SubscriptionCustomersList {...props} />,
    },
    {
      key: 'subscriptionHistory',
      label: 'Minhas Solicitações',
      component: <SubscriptionHistory {...props} />,
    },
  ];

  const [selectedTab, setSelectedTab] = useState<string>(initialTab || tabs[0].key);

  useEffect(() => {
    if (initialTab) {
      setSelectedTab(initialTab);
    }
  }, [initialTab]);

  return (
    <Stack flex={1}>
      <UI.TabSwitch
        testId="tab-switch"
        tabs={tabs}
        selectedTab={selectedTab}
        onTabPress={setSelectedTab}
        isMobile={isMobile}
        isLoading={false}
      />
    </Stack>
  );
};
